export default {
  /* 登录 */
  loginapi: '/accountApi/account/authen/sysuser/userLogin',
  // 新增用户
  adduserapi: '/accountApi/account/authen/sysuser/addsysUser',

  // 冻结用户API
  disabledSysUserapi: '/accountApi/account/authen/sysuser/disabledSysUser',
  // 分页查询用户登录记录
  queryLoginRecordapi: '/accountApi/account/authen/sysuser/queryLoginRecord',
  // 修改用户密码
  editpassapi: '/accountApi/account/authen/sysuser/editUserpass',
  // 用户角色分页列表
  //roleListapi: '/accountApi/account/authen/sysrole/queryRolePage',
  roleListapi: '/backstageApi/account/backstage/sysRole/queryRolePage',
  // 获取所有角色
  roleAllapi: '/accountApi/account/authen/sysrole/queryallRole',
  // 根据渠道id获取角色
  selectRoleListByChannelIdApi: '/backstageApi/account/backstage/sysRole/selectRoleListByChannelId',
  // 新增角色
  //addroleapi: '/accountApi/account/authen/sysrole/addSysRole',
  addroleapi: '/backstageApi/account/backstage/sysRole/addSysRole',
  // 编辑角色
  //editroleapi: '/accountApi/account/authen/sysrole/editSysRole',
  editroleapi: '/backstageApi/account/backstage/sysRole/editSysRole',
  // 菜单分页列表
  menuListapi: '/accountApi/account/authen/sysmenu/querySysMenuPage',
  // 查询所有系统信息
  getmanagementAllapi: '/accountApi/account/manage/management/queryManagementAll',
  // 分页查询系统信息
  queryManagementPageapi: '/accountApi/account/manage/management/queryManagementPage',
  // 新增系统信息
  addManagementapi: '/accountApi/account/manage/management/addManagement',
  // 编辑系统信息
  editManagementapi: '/accountApi/account/manage/management/editManagement',
  // 根据系统ID查询所有菜单信息
  getSysmidMenuapi: '/accountApi/account/authen/sysmenu/getSysmidMenu',
  // 新增菜单信息
  addSysMenuapi: '/accountApi/account/authen/sysmenu/addSysMenu',
  // 编辑菜单信息
  editSysMenuapi: '/accountApi/account/authen/sysmenu/editSysMenu',
  // 根据角色ID查询关联的菜单ID，用于回显,有bug
  queryRoleIdMenuapi: '/accountApi/account/authen/sysmenu/queryRoleIdMenu',
  // 根据角色id+系统id
  queryRoleIdMenu: '/backstageApi/sysMenu/queryRoleIdMenu',
  // 根据系统ID获取所有树形菜单
  querytreeMenuapi: '/accountApi/account/authen/sysmenu/querytreeMenu',
  // 根据角色获取角色按钮
  queryMenuCodeAllapi: '/accountApi/account/authen/sysmenu/queryMenuCodeAll',
  // 首页左侧菜单，有bug
  queryHomeTreeMenuapi: '/accountApi/account/authen/sysmenu/queryHomeTreeMenu',
  // 首页左侧菜单
  queryHomeTreeMenu: '/backstageApi/sysMenu/queryHomeTreeMenu',
  // 编辑用户信息
  editAppUserapi: '/accountApi/account/authen/sysuser/editAppUser',
  // 更新密码
  updatePass: '/backstageApi/account/backstage/sysUser/updatePass',

  // 页面按钮
  pageBtn: '/accountApi/account/authen/sysmenu/queryPageBtn',



}



// WEBPACK FOOTER //
// ./src/api/user/user.js